<script setup lang="ts">
/** Label + control (default slot) + inline error or hint. The control is nested in the label. */
defineProps<{ label: string; error?: string; hint?: string }>()
</script>

<template>
  <label class="field">
    <span class="label">{{ label }}</span>
    <slot />
    <span v-if="error" class="error" role="alert">{{ error }}</span>
    <span v-else-if="hint" class="hint">{{ hint }}</span>
  </label>
</template>

<style scoped>
.field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
}
.label {
  font-size: 0.85rem;
  font-weight: 500;
}
.error {
  font-size: 0.8rem;
  color: var(--loss);
}
.hint {
  font-size: 0.8rem;
  color: var(--fg-muted);
}
</style>
